import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import type { IAdminBillingUtilitiesRequest } from './useAdminSelfServicePaymentUrlMutation';

/**
 * Resolves the Chargify/Maxio proforma (next) invoice preview URL for a customer via
 * `GET admin/BillingUtilities/GetProformaInvoiceUrl`. Returns the URL for the caller to open.
 *
 * Mutations have no MutationCache, so the error toast is wired here explicitly.
 */
export function useAdminProformaInvoiceUrlMutation() {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({ chargifyCustomerId }: IAdminBillingUtilitiesRequest) =>
			userSession.webServiceHelper.callAsync<string>(
				`admin/BillingUtilities/GetProformaInvoiceUrl?chargifyCustomerId=${encodeURIComponent(chargifyCustomerId)}`,
				'GET'
			),
		onError: () => toast.error('Failed to get the invoice preview. Please try again.'),
	});
}
